import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import ObliqueIcon from '@/components/icons/ObliqueIcon';

/**
 * CRM Module Navigation Items
 * @param {Object} props - { isCollapsed, getNavItemStyle, ThemeCalendarIcon }
 */
const CRMSidebar = ({ isCollapsed, getNavItemStyle, ThemeCalendarIcon }) => {
    const [ticketTooltip, setTicketTooltip] = useState(false);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', marginBottom: '8px' }}>
            {/* Main Navigation */}
            <NavLink to="/crm" end style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="dashboard" size={22} isActive={isActive} strokeScale={1.1} />
                        {!isCollapsed && <span>CRM Dashboard</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/reports" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="bar_chart" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Reports</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/leads" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="group_add" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Leads</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/pipeline" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="handshake" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Deals</span>}
                    </>
                )}
            </NavLink>
            
            <NavLink to="/crm/campaigns" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="ads_click" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Campaigns</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/communication" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="forum" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Communication</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/orders" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="local_mall" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Orders</span>}
                    </>
                )}
            </NavLink>

            <div style={{ position: 'relative' }}
                onMouseEnter={() => setTicketTooltip(true)}
                onMouseLeave={() => setTicketTooltip(false)}
            >
                <NavLink to="/crm/tickets" style={({ isActive }) => getNavItemStyle(isActive)}>
                    {({ isActive }) => (
                        <>
                            <ObliqueIcon name="support_agent" isActive={isActive} size={22} strokeScale={1.1} />
                            {!isCollapsed && <span>Tickets</span>}
                        </>
                    )}
                </NavLink>
                {/* Tooltip */}
                {ticketTooltip && !isCollapsed && (
                    <div style={{
                        position: 'absolute',
                        left: '100%',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        marginLeft: '8px',
                        padding: '8px 12px',
                        background: 'var(--bg-elevated, #1f2937)',
                        color: 'var(--text-on-dark, #f9fafb)',
                        borderRadius: '8px',
                        fontSize: '11px',
                        lineHeight: '1.5',
                        whiteSpace: 'nowrap',
                        zIndex: 999,
                        boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
                        pointerEvents: 'none',
                        animation: 'fadeInUp 0.15s ease-out'
                    }}>
                        <div style={{ fontWeight: 600, marginBottom: '2px' }}>Support & Escalation Tickets</div>
                        <div style={{ opacity: 0.7 }}>Manage client issues, feature requests & onboarding tasks</div>
                    </div>
                )}
            </div>

            <NavLink to="/crm/inbox" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="forum" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Unified Inbox</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/planner" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ThemeCalendarIcon size={22} isActive={isActive} />
                        {!isCollapsed && <span>Calendar</span>}
                    </>
                )}
            </NavLink>

            <NavLink to="/crm/automation" style={({ isActive }) => getNavItemStyle(isActive)}>
                {({ isActive }) => (
                    <>
                        <ObliqueIcon name="flash_on" isActive={isActive} size={22} strokeScale={1.1} />
                        {!isCollapsed && <span>Automation</span>}
                    </>
                )}
            </NavLink>

            <button style={{ ...getNavItemStyle(false), border: 'none', background: 'transparent', textAlign: 'left', marginTop: '4px' }}>
                <ObliqueIcon name="more_horiz" size={22} strokeScale={1.1} />
                {!isCollapsed && <span>More Options</span>}
            </button>
        </div>
    );
};

export default CRMSidebar;
